(function () {
  if (window.kurashikinuProductReviewSummary) {
    window.kurashikinuProductReviewSummary(document);
    return;
  }

  const selector = '.product__info-container .review-summary-container.product__review-summary';
  const observers = new WeakMap();

  function watchSummaries(root) {
    const summaries = Array.from(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) summaries.push(root);

    summaries.forEach((summary) => {
      if (observers.has(summary)) return;

      const observer = new MutationObserver(() => {
        if (!summary.querySelector('[data-no-review="true"]')) return;

        observer.disconnect();
        observers.delete(summary);
        summary.remove();
      });

      observers.set(summary, observer);
      observer.observe(summary, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-no-review']
      });

      if (summary.querySelector('[data-no-review="true"]')) {
        observer.disconnect();
        observers.delete(summary);
        summary.remove();
      }
    });
  }

  window.kurashikinuProductReviewSummary = watchSummaries;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => watchSummaries(document));
  } else {
    watchSummaries(document);
  }

  document.addEventListener('shopify:section:load', (event) => watchSummaries(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((summary) => {
      observers.get(summary)?.disconnect();
      observers.delete(summary);
    });
  });
})();
